<template>
  <div class="top-bar">
    <router-link :to="{ name: 'IndexPage', params: {} }">
      <h1 :class="{'jx-gy': jxgy}">{{indexName}}</h1>
    </router-link>
    <span class="suffix" v-if="currentPageTitle">/ {{currentPageTitle}}</span>
    <div v-if="showTop" class="envShow">{{envShow}}</div>
    <el-menu
    class="el-menu-demo"
    mode="horizontal"
    :unique-opened="true"
    >
    <!-- router -->
      <!-- <el-menu-item index="1">处理中心</el-menu-item> -->
      <el-menu-item index="0" @click="downloadApp">
        <icon name="icon-download" scale="2" class="topbar-icon"></icon>下载京西到家商家版
      </el-menu-item>
      <el-menu-item index="2" disabled>
        <icon name="icon-msg" scale="2" class="topbar-icon"></icon>消息中心
        <el-badge value="0" />
      </el-menu-item>
      <el-submenu index="1">
        <template slot="title"><icon name="icon-user" scale="1.6" class="topbar-icon"></icon>{{user.name || user.id}}</template>
        <el-menu-item index="2-1" @click.native="resetPass">修改密码</el-menu-item>
      </el-submenu>
      <el-menu-item index="2-2" @click.native="loginout"><icon name="icon-login-out" scale="1.6" class="topbar-icon"></icon>退出登录</el-menu-item>
    </el-menu>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="resetPassShow"
      width="380px"
      :close-on-click-modal="false"
      :before-close="beforeClose"
    >
      <el-form :model="resetForm" ref="resetForm" inline label-width="100px" size="small" :rules="rules2" status-icon>
        <el-form-item label="姓名:">
          {{user.name}}
        </el-form-item>
        <br>
        <el-form-item label="用户名:">
          {{user.userID2}}
        </el-form-item>
        <el-form-item label="手机号:">
          {{user.mobile}}
        </el-form-item>
        <el-form-item label="原密码:" v-if="hasPwd">
          <el-input type="password" placeholder="请输入原密码" v-model="resetForm.oldPwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="newPwd">
          <el-input type="password" placeholder="请输入新密码" v-model="resetForm.newPwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="newPwd2">
          <el-input type="password" placeholder="请再次输入新密码" v-model="resetForm.newPwd2" autocomplete="off"></el-input>
        </el-form-item>
        <div style="text-align: right;padding-right: 40px;">
          <el-button size="small" @click="resetPassShow = false">取消</el-button>
          <el-button size="small" @click="handleReset" type="primary">修改</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import $ajax from 'axios'
import {hideLoad} from '@/tools/loading.js'
import {md52} from '@/tools/md5'
import {apiEdition} from '@/config'
export default {
  name: 'TopBar',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.resetForm.newPwd2 !== '') {
          this.$refs.resetForm.validateField('newPwd2')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      jxgy: false,
      currentPageTitle: '',
      hasPwd: false,
      resetPassShow: false,
      resetForm: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      rules2: {
        newPwd: [
          { validator: validatePass, trigger: 'change' }
        ],
        newPwd2: [
          { validator: validatePass2, trigger: 'change' }
        ]
      },
      indexName: ''
    }
  },
  created () {
    this.currentPageTitle = this.$route.meta.title
    if (window.location.href.indexOf('jxgy') !== -1) {
      document.title = '京西果园-管理平台'
      document.querySelector('[rel*="icon"]').href = 'static/img/faviconGY.jpg'
      this.indexName = '京西果园·管理平台'
      this.jxgy = true
    } else if(window.location.href.indexOf('gblm') !== -1){
      document.title = '京西宠物-管理平台'
      document.querySelector('[rel*="icon"]').href = 'static/img/favicon.png'
      this.indexName = '京西宠物·管理平台'
      this.jxgy = false
    }else{
      document.title = '京西到家-管理平台'
      document.querySelector('[rel*="icon"]').href = 'static/img/favicon.png'
      this.indexName = '京西到家·管理平台'
      this.jxgy = false
    }
  },
  methods: {
    loginout () {
      $ajax.delete('v2/auth2/Logout').then(() => {
        hideLoad()
        // 清除登录信息
        this.$store.dispatch('LoginOut')
        localStorage.removeItem('mobile')
        localStorage.removeItem('userID')
        // 跳转到首页
        this.$router.push('/login')
      }).catch(e => {
        hideLoad()
        localStorage.removeItem('mobile')
        localStorage.removeItem('userID')
        this.$store.dispatch('LoginOut')
        this.$router.push('/login')
      })
    },
    // 下载商家版软件
    downloadApp() {
      window.open('https://app.jxc4.com')
    },
    // 请求修改
    async handleReset () {
      this.$refs.resetForm.validate(async (valid) => {
        if (valid) {
          let form = new FormData()
          if (this.resetForm.oldPwd) form.append('oldPwd', md52(this.resetForm.oldPwd))
          form.append('newPwd', md52(this.resetForm.newPwd))
          try {
            let {data} = await $ajax.put('v2/auth2/ChangePassword', form, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            let {code, desc} = data
            if (code === '0') {
              this.$message({
                message: '设置密码成功',
                type: 'success'
              })
              this.$refs.resetForm.resetFields()
              this.resetPassShow = false
            } else {
              this.$message.error(desc)
            }
          } catch (e) {
            console.error(e)
            this.$message.error('设置密码失败')
          } finally {
            hideLoad()
          }
        }
      })
    },
    // 修改密码
    async resetPass () {
      this.resetForm.oldPwd = ''
      this.resetForm.newPwd = ''
      this.resetForm.newPwd2 = ''
      this.resetPassShow = true
      // let {data} = await $ajax.get('v2/auth/GetUserInfo')
      let {data} = await $ajax.get('v2/user2/GetBindAuthInfo')
      let auths = JSON.parse(data.data)
      // type
      // 已经有密码
      if (auths.find(item => item.type === 'localpass')) this.hasPwd = true
      hideLoad()
    },
    // 关闭前
    beforeClose (done) {
      this.$refs.resetForm.resetFields()
      done()
    }
  },
  computed: {
    user () {
      return this.$store.getters.userInfo
    },
    showTop () {
      return process.env.NODE_ENV === 'development'
    },
    envShow () {
      return apiEdition === 'v1' ? '正式服务器' : 'beta服务器'
    }

  },
  watch: {
    '$route': function (newVal, oldVal) {
      this.currentPageTitle = newVal.meta.title
    }
  }
}
</script>

<style lang="scss">
.top-bar {
  // text-align: right;
  background: white;
  border-bottom: 1px solid #e6e6e6;
  overflow: hidden;
  .el-menu {
    display: inline-block;
    border: none;
    float: right;
  }
  .topbar-icon {
    vertical-align: -3px;
    margin-right: 5px;
  }
  h1 {
    float: left;
    font-size: 18px;
    // font-style:italic;
    margin: 0;
    height: 60px;
    line-height: 60px;
    padding-left: 65px;
    // background:  10px center no-repeat;
    background-image: url(/static/img/logo200.png);
    background-repeat: no-repeat;
    background-position: 10px center;
    background-size: 50px;
    // color: #1989fa;
    color: rgb(46, 46, 46);
    font-weight: bold;
  }
  .jx-gy {
    background-image: url(/static/img/jxgy.jpg);
  }
  .suffix {
    float: left;
    font-size: 14px;
    // font-style:italic;
    margin: 0;
    height: 60px;
    line-height: 60px;
    padding-left: 10px;
    color: #606266;
    font-weight: bold;
  }
  .envShow {
    position: fixed;
    top: 8px;
    left: 50%;
    transform: translate(-50%, 0);
    font-weight: bold;
    color: #409EFF;
    font-size: 20px;
    border: 4px solid red;
    padding: 10px;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu/topbar.vue